/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EventTimeType = "Date" | "DateTime" | "%future added value";
export type IntervalDefinitionFreqTypeEnum = "Daily" | "Monthly" | "Weekly" | "Yearly" | "%future added value";
export type QuotaStatusBannerEnum = "ApproachingLimit" | "NoEnforcement" | "ReachedLimit" | "%future added value";
export type SubjectUrnTypeEnum = "Email" | "Integration" | "Org" | "Person" | "Phone" | "Services" | "Team" | "User" | "%future added value";
export type SuggestedAutopilotSettingsV3MovementType = "Day" | "Week" | "%future added value";
export type TimeSlot = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type Event_eventParent = {
    readonly id: string;
    readonly externalEventId: string;
    readonly syncedOriginEventErrorable: {
        readonly title?: string | null | undefined;
        readonly description?: string | null | undefined;
        readonly descriptionOmitted?: boolean | null | undefined;
        readonly locked?: boolean | null | undefined;
        readonly isAllDay?: boolean | null | undefined;
        readonly isClockwiseEvent?: boolean | undefined;
        readonly createdMillis?: unknown | null | undefined;
        readonly updatedMillis?: unknown | null | undefined;
        readonly hangoutLink?: string | null | undefined;
        readonly organizer?: {
            readonly urnValue: string;
        } | null | undefined;
        readonly eventKey?: {
            readonly externalEventId: string;
        } | undefined;
        readonly annotatedEvent?: {
            readonly orgTags: ReadonlyArray<{
                readonly tag: string;
                readonly state: {
                    readonly subjectType: SubjectUrnTypeEnum;
                    readonly subjectValue: string;
                    readonly value: string | null;
                };
            }> | null;
        } | null | undefined;
        readonly attendees?: ReadonlyArray<{
            readonly organizer: boolean | null;
            readonly displayName: string | null;
            readonly urnValue: string;
            readonly " $fragmentRefs": FragmentRefs<"EventSummaryRoom_attendees">;
        }> | undefined;
        readonly startTime?: {
            readonly millis: number;
        } | undefined;
        readonly endTime?: {
            readonly millis: number;
        } | undefined;
        readonly recurrenceRules?: {
            readonly firstInstanceStartTime: {
                readonly type: EventTimeType;
                readonly dateOrDateTime: string;
                readonly timeZone: string | null;
                readonly millis: number;
                readonly offsetMinutes: number | null;
            } | null;
            readonly timeZone: string;
            readonly interval: {
                readonly interval: number;
                readonly byDay: string | null;
                readonly bySetPos: ReadonlyArray<number | null> | null;
                readonly freqType: IntervalDefinitionFreqTypeEnum;
                readonly count: number | null;
                readonly untilTime: {
                    readonly type: EventTimeType;
                    readonly dateOrDateTime: string;
                    readonly timeZone: string | null;
                    readonly millis: number;
                    readonly offsetMinutes: number | null;
                } | null;
            } | null;
        } | null | undefined;
        readonly message?: string | null | undefined;
        readonly statusCode?: number | null | undefined;
        readonly " $fragmentRefs": FragmentRefs<"EventSummary_event">;
    } | null;
    readonly events: ReadonlyArray<{
        readonly calendarIds: ReadonlyArray<string>;
        readonly isAllDay: boolean | null;
        readonly isClockwiseEvent: boolean;
        readonly locked: boolean | null;
        readonly scrubbedEvent: boolean;
        readonly organizerPerson: {
            readonly emails?: ReadonlyArray<string> | undefined;
            readonly isYou?: boolean | undefined;
            readonly primaryEmail?: string | undefined;
            readonly userId?: string | null | undefined;
        } | null;
        readonly organizerOrgPerson: {
            readonly isYou?: boolean | undefined;
            readonly userId?: string | null | undefined;
            readonly personId?: string | undefined;
            readonly primaryCalendarId?: string | undefined;
        } | null;
        readonly annotatedEvent: {
            readonly userTags: ReadonlyArray<{
                readonly tag: string;
                readonly states: ReadonlyArray<{
                    readonly value: string | null;
                    readonly subjectType: SubjectUrnTypeEnum;
                    readonly subjectValue: string;
                    readonly lastModified: number;
                    readonly active: boolean;
                }> | null;
            }> | null;
            readonly orgTags: ReadonlyArray<{
                readonly tag: string;
                readonly state: {
                    readonly subjectType: SubjectUrnTypeEnum;
                    readonly subjectValue: string;
                    readonly value: string | null;
                    readonly active: boolean;
                };
            }> | null;
        } | null;
        readonly eventKey: {
            readonly id: string;
            readonly calendarIds: ReadonlyArray<string> | null;
            readonly externalEventId: string;
            readonly hashedCalendars: string | null;
            readonly orgId: string | null;
        };
        readonly startTime: {
            readonly millis: number;
            readonly dateOrDateTime: string;
            readonly timeZone: string | null;
        };
        readonly endTime: {
            readonly millis: number;
        };
        readonly title: string | null;
        readonly attendees: ReadonlyArray<{
            readonly displayName: string | null;
            readonly urnValue: string;
        }>;
        readonly organizer: {
            readonly urnValue: string;
        } | null;
        readonly attendeePeople: {
            readonly __typename: "PersonList";
            readonly list: ReadonlyArray<{
                readonly id: string;
                readonly emails: ReadonlyArray<string>;
                readonly primaryEmail: string;
                readonly profile: {
                    readonly givenName: string | null;
                    readonly familyName: string | null;
                    readonly externalImageUrl: string | null;
                } | null;
                readonly isYou: boolean;
            }>;
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        };
        readonly recurrenceRules: {
            readonly timeZone: string;
        } | null;
        readonly suggestedAutopilotSettingsResponseV3: {
            readonly __typename: "SuggestedAutopilotSettingsResponseV3";
            readonly intersectionOfAttendeesMeetingHours: {
                readonly minSlot: {
                    readonly dayOffset: number;
                    readonly timeSlot: TimeSlot;
                };
                readonly maxSlot: {
                    readonly dayOffset: number;
                    readonly timeSlot: TimeSlot;
                };
            } | null;
            readonly calendarIdToMeetingHours: ReadonlyArray<{
                readonly calendarId: string;
                readonly dayOffsetTimeSlotRanges: ReadonlyArray<{
                    readonly minSlot: {
                        readonly dayOffset: number;
                        readonly timeSlot: TimeSlot;
                    };
                    readonly maxSlot: {
                        readonly dayOffset: number;
                        readonly timeSlot: TimeSlot;
                    };
                }>;
            }>;
            readonly suggestedAutopilotSettings: {
                readonly isRoomFlexible: boolean;
                readonly movementType: SuggestedAutopilotSettingsV3MovementType;
                readonly allowedEndTime: {
                    readonly dayOffset: number;
                    readonly timeSlot: TimeSlot;
                } | null;
                readonly allowedStartTime: {
                    readonly dayOffset: number;
                    readonly timeSlot: TimeSlot;
                } | null;
            };
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        };
        readonly moveRangeInLocalTimeV3: {
            readonly __typename: "MoveRangeInLocalTimeV3";
            readonly allowedStartTimeInclusive: {
                readonly dayOffset: number;
                readonly timeSlot: TimeSlot;
            } | null;
            readonly allowedEndTimeInclusive: {
                readonly dayOffset: number;
                readonly timeSlot: TimeSlot;
            } | null;
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        };
        readonly featureStatesForOrganizer: ({
            readonly __typename: "FeatureStates";
            readonly mixedFreemiumOrgUIState: {
                readonly autopilotPaused: boolean;
                readonly moveRangesEnabled: boolean;
                readonly quotaStatusBanner: QuotaStatusBannerEnum;
            };
        } | {
            readonly __typename: "GraphEntityError";
            readonly statusCode: number | null;
            readonly message: string | null;
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        }) | null;
        readonly " $fragmentRefs": FragmentRefs<"AutopilotFormSaveOnEdit_event" | "EventSummary_event" | "EventSmartHoldInfo_event" | "EventPeople_event" | "AutopilotEventHistory_event">;
    }>;
    readonly " $fragmentRefs": FragmentRefs<"EventPersonalCalendarInfo_eventParent" | "AutopilotFormSaveOnEdit_eventParent" | "EventTeam_eventParent" | "EventSummary_eventParent">;
    readonly " $refType": "Event_eventParent";
};
export type Event_eventParent$data = Event_eventParent;
export type Event_eventParent$key = {
    readonly " $data"?: Event_eventParent$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"Event_eventParent">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "externalEventId",
        "storageKey": null
    } as any, v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "locked",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isAllDay",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isClockwiseEvent",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urnValue",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "concreteType": "Attendee",
        "kind": "LinkedField",
        "name": "organizer",
        "plural": false,
        "selections": [
            (v6 /*: any*/)
        ],
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tag",
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "subjectType",
        "storageKey": null
    } as any, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "subjectValue",
        "storageKey": null
    } as any, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
    } as any, v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayName",
        "storageKey": null
    } as any, v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "millis",
        "storageKey": null
    } as any, v14 = [
        (v13 /*: any*/)
    ], v15 = {
        "alias": null,
        "args": null,
        "concreteType": "EventTime",
        "kind": "LinkedField",
        "name": "endTime",
        "plural": false,
        "selections": (v14 /*: any*/),
        "storageKey": null
    } as any, v16 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dateOrDateTime",
        "storageKey": null
    } as any, v17 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "timeZone",
        "storageKey": null
    } as any, v18 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
        } as any,
        (v16 /*: any*/),
        (v17 /*: any*/),
        (v13 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "offsetMinutes",
            "storageKey": null
        } as any
    ], v19 = [
        {
            "kind": "Variable",
            "name": "calendarId",
            "variableName": "calendarId"
        } as any
    ], v20 = {
        "args": (v19 /*: any*/),
        "kind": "FragmentSpread",
        "name": "EventSummary_event"
    } as any, v21 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v22 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusCode",
        "storageKey": null
    } as any, v23 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "calendarIds",
        "storageKey": null
    } as any, v24 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "emails",
        "storageKey": null
    } as any, v25 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isYou",
        "storageKey": null
    } as any, v26 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primaryEmail",
        "storageKey": null
    } as any, v27 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userId",
        "storageKey": null
    } as any, v28 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "active",
        "storageKey": null
    } as any, v29 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v30 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dayOffset",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeSlot",
            "storageKey": null
        } as any
    ], v31 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "DayOffsetTimeSlot",
            "kind": "LinkedField",
            "name": "minSlot",
            "plural": false,
            "selections": (v30 /*: any*/),
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "concreteType": "DayOffsetTimeSlot",
            "kind": "LinkedField",
            "name": "maxSlot",
            "plural": false,
            "selections": (v30 /*: any*/),
            "storageKey": null
        } as any
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "calendarId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isOnAPHistory"
            }
        ],
        "kind": "Fragment",
        "metadata": null,
        "name": "Event_eventParent",
        "selections": [
            (v0 /*: any*/),
            (v1 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "syncedOriginEventErrorable",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v2 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "description",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "descriptionOmitted",
                                "storageKey": null
                            },
                            (v3 /*: any*/),
                            (v4 /*: any*/),
                            (v5 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "createdMillis",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "updatedMillis",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hangoutLink",
                                "storageKey": null
                            },
                            (v7 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventKey",
                                "kind": "LinkedField",
                                "name": "eventKey",
                                "plural": false,
                                "selections": [
                                    (v1 /*: any*/)
                                ],
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "AnnotatedEvent",
                                "kind": "LinkedField",
                                "name": "annotatedEvent",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "OrgTag",
                                        "kind": "LinkedField",
                                        "name": "orgTags",
                                        "plural": true,
                                        "selections": [
                                            (v8 /*: any*/),
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "TagState",
                                                "kind": "LinkedField",
                                                "name": "state",
                                                "plural": false,
                                                "selections": [
                                                    (v9 /*: any*/),
                                                    (v10 /*: any*/),
                                                    (v11 /*: any*/)
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Attendee",
                                "kind": "LinkedField",
                                "name": "attendees",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "organizer",
                                        "storageKey": null
                                    },
                                    (v12 /*: any*/),
                                    (v6 /*: any*/),
                                    {
                                        "args": null,
                                        "kind": "FragmentSpread",
                                        "name": "EventSummaryRoom_attendees"
                                    }
                                ],
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventTime",
                                "kind": "LinkedField",
                                "name": "startTime",
                                "plural": false,
                                "selections": (v14 /*: any*/),
                                "storageKey": null
                            },
                            (v15 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "RecurrenceRules",
                                "kind": "LinkedField",
                                "name": "recurrenceRules",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "EventTime",
                                        "kind": "LinkedField",
                                        "name": "firstInstanceStartTime",
                                        "plural": false,
                                        "selections": (v18 /*: any*/),
                                        "storageKey": null
                                    },
                                    (v17 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "IntervalDefinition",
                                        "kind": "LinkedField",
                                        "name": "interval",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "interval",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "byDay",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "bySetPos",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "freqType",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "count",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "EventTime",
                                                "kind": "LinkedField",
                                                "name": "untilTime",
                                                "plural": false,
                                                "selections": (v18 /*: any*/),
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            },
                            (v20 /*: any*/)
                        ],
                        "type": "Event",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v21 /*: any*/),
                            (v22 /*: any*/)
                        ],
                        "type": "GraphEntityError",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "events",
                "plural": true,
                "selections": [
                    (v23 /*: any*/),
                    (v4 /*: any*/),
                    (v5 /*: any*/),
                    (v3 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "scrubbedEvent",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "organizerPerson",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    (v24 /*: any*/),
                                    (v25 /*: any*/),
                                    (v26 /*: any*/),
                                    (v27 /*: any*/)
                                ],
                                "type": "Person",
                                "abstractKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "organizerOrgPerson",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    (v25 /*: any*/),
                                    (v27 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "personId",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "primaryCalendarId",
                                        "storageKey": null
                                    }
                                ],
                                "type": "OrgPerson",
                                "abstractKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "AnnotatedEvent",
                        "kind": "LinkedField",
                        "name": "annotatedEvent",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserTag",
                                "kind": "LinkedField",
                                "name": "userTags",
                                "plural": true,
                                "selections": [
                                    (v8 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TagState",
                                        "kind": "LinkedField",
                                        "name": "states",
                                        "plural": true,
                                        "selections": [
                                            (v11 /*: any*/),
                                            (v9 /*: any*/),
                                            (v10 /*: any*/),
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "lastModified",
                                                "storageKey": null
                                            },
                                            (v28 /*: any*/)
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrgTag",
                                "kind": "LinkedField",
                                "name": "orgTags",
                                "plural": true,
                                "selections": [
                                    (v8 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TagState",
                                        "kind": "LinkedField",
                                        "name": "state",
                                        "plural": false,
                                        "selections": [
                                            (v9 /*: any*/),
                                            (v10 /*: any*/),
                                            (v11 /*: any*/),
                                            (v28 /*: any*/)
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventKey",
                        "kind": "LinkedField",
                        "name": "eventKey",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            (v23 /*: any*/),
                            (v1 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hashedCalendars",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "orgId",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventTime",
                        "kind": "LinkedField",
                        "name": "startTime",
                        "plural": false,
                        "selections": [
                            (v13 /*: any*/),
                            (v16 /*: any*/),
                            (v17 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v15 /*: any*/),
                    (v2 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Attendee",
                        "kind": "LinkedField",
                        "name": "attendees",
                        "plural": true,
                        "selections": [
                            (v12 /*: any*/),
                            (v6 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v7 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "attendeePeople",
                        "plural": false,
                        "selections": [
                            (v29 /*: any*/),
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Person",
                                        "kind": "LinkedField",
                                        "name": "list",
                                        "plural": true,
                                        "selections": [
                                            (v0 /*: any*/),
                                            (v24 /*: any*/),
                                            (v26 /*: any*/),
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "UserProfile",
                                                "kind": "LinkedField",
                                                "name": "profile",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "givenName",
                                                        "storageKey": null
                                                    },
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "familyName",
                                                        "storageKey": null
                                                    },
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "externalImageUrl",
                                                        "storageKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            },
                                            (v25 /*: any*/)
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "type": "PersonList",
                                "abstractKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "RecurrenceRules",
                        "kind": "LinkedField",
                        "name": "recurrenceRules",
                        "plural": false,
                        "selections": [
                            (v17 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "suggestedAutopilotSettingsResponseV3",
                        "plural": false,
                        "selections": [
                            (v29 /*: any*/),
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "DayOffsetTimeSlotRange",
                                        "kind": "LinkedField",
                                        "name": "intersectionOfAttendeesMeetingHours",
                                        "plural": false,
                                        "selections": (v31 /*: any*/),
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SuggestedAutotpilotSettingsResponseV3CalendarIdMeetingHours",
                                        "kind": "LinkedField",
                                        "name": "calendarIdToMeetingHours",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "calendarId",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "DayOffsetTimeSlotRange",
                                                "kind": "LinkedField",
                                                "name": "dayOffsetTimeSlotRanges",
                                                "plural": true,
                                                "selections": (v31 /*: any*/),
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SuggestedAutopilotSettingsV3",
                                        "kind": "LinkedField",
                                        "name": "suggestedAutopilotSettings",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "isRoomFlexible",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "movementType",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "DayOffsetTimeSlot",
                                                "kind": "LinkedField",
                                                "name": "allowedEndTime",
                                                "plural": false,
                                                "selections": (v30 /*: any*/),
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "DayOffsetTimeSlot",
                                                "kind": "LinkedField",
                                                "name": "allowedStartTime",
                                                "plural": false,
                                                "selections": (v30 /*: any*/),
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "type": "SuggestedAutopilotSettingsResponseV3",
                                "abstractKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "moveRangeInLocalTimeV3",
                        "plural": false,
                        "selections": [
                            (v29 /*: any*/),
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "DayOffsetTimeSlot",
                                        "kind": "LinkedField",
                                        "name": "allowedStartTimeInclusive",
                                        "plural": false,
                                        "selections": (v30 /*: any*/),
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "DayOffsetTimeSlot",
                                        "kind": "LinkedField",
                                        "name": "allowedEndTimeInclusive",
                                        "plural": false,
                                        "selections": (v30 /*: any*/),
                                        "storageKey": null
                                    }
                                ],
                                "type": "MoveRangeInLocalTimeV3",
                                "abstractKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "featureStatesForOrganizer",
                        "plural": false,
                        "selections": [
                            (v29 /*: any*/),
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "MixedFreemiumOrgUiState",
                                        "kind": "LinkedField",
                                        "name": "mixedFreemiumOrgUIState",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "autopilotPaused",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "moveRangesEnabled",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "quotaStatusBanner",
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "type": "FeatureStates",
                                "abstractKey": null
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    (v22 /*: any*/),
                                    (v21 /*: any*/)
                                ],
                                "type": "GraphEntityError",
                                "abstractKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "args": (v19 /*: any*/),
                        "kind": "FragmentSpread",
                        "name": "AutopilotFormSaveOnEdit_event"
                    },
                    (v20 /*: any*/),
                    {
                        "args": (v19 /*: any*/),
                        "kind": "FragmentSpread",
                        "name": "EventSmartHoldInfo_event"
                    },
                    {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "EventPeople_event"
                    },
                    {
                        "args": (v19 /*: any*/),
                        "kind": "FragmentSpread",
                        "name": "AutopilotEventHistory_event"
                    }
                ],
                "storageKey": null
            },
            {
                "args": (v19 /*: any*/),
                "kind": "FragmentSpread",
                "name": "EventPersonalCalendarInfo_eventParent"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AutopilotFormSaveOnEdit_eventParent"
            },
            {
                "args": (v19 /*: any*/),
                "kind": "FragmentSpread",
                "name": "EventTeam_eventParent"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventSummary_eventParent"
            }
        ],
        "type": "EventParent",
        "abstractKey": null
    } as any;
})();
(node as any).hash = 'f7e7c40e6a142fd9aecac8feeced0aed';
export default node;
